module.exports = "/_next/static/images/GDSCWOWPUNE-7f299bb42d29f13d472a90e48251180a.jpg";